import * as React from "react";
import { Search } from "lucide-react";

import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

const searchIconClassName =
  "text-muted-foreground pointer-events-none size-4 shrink-0 transition-colors group-hover:text-foreground group-focus-within:text-[var(--accent-tech)] group-has-[input:disabled]:text-muted-foreground/50";

const searchInputClassName =
  "rounded-[var(--radius-button)] bg-[var(--bg-panel-0)] pl-8 disabled:bg-[var(--bg-panel-1)]";

type SearchInputProps = React.ComponentProps<typeof Input> & {
  containerClassName?: string;
  "data-testid"?: string;
};

function SearchInput({
  className,
  containerClassName,
  disabled,
  "data-testid": testId,
  ...props
}: SearchInputProps): React.ReactElement {
  return (
    <div
      data-slot="search-input-wrapper"
      data-testid={testId ? `${testId}-wrapper` : undefined}
      data-disabled={disabled || undefined}
      className={cn("group relative w-full", containerClassName)}
    >
      <Search
        aria-hidden
        data-testid={testId ? `${testId}-icon` : undefined}
        className={cn(searchIconClassName, "absolute top-1/2 left-2.5 -translate-y-1/2")}
      />
      <Input
        {...props}
        disabled={disabled}
        data-testid={testId}
        className={cn(searchInputClassName, className)}
      />
    </div>
  );
}

export { SearchInput, searchIconClassName };
